import CancelIcon from "@mui/icons-material/Cancel";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Button,
  Tab,
  Tabs,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
  Toolbar,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import _without from "lodash/without";
import { useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { AppDataContext } from "../../common/appContext";
import { handleError } from "../../helper";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import { LeaderDashboardService } from "../../services/leaderDashboard.Service";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import ComparePlayersAnthros from "./ComparePlayersAnthros";
import ComparePlayersSAA from "./ComparePlayersSAA";
import ComparePlayersShootingDrills from "./ComparePlayersShootingDrill";
// import ReactExport from "react-data-export";
import reactDom from "react-dom";
import {
  anthrosStations,
  shootingStations,
  strengthAndAgilityStations,
} from "../../configs/AppSettings";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

var positionSelected = false;
var playerSelected = false;
var collegeSelected = false;
function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
function getStyles1(name, pName, theme) {
  return {
    fontWeight:
      pName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
    paddingRight: "20px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },

  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "#1d428a",
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  excelButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: "1",
    paddingRight: theme.spacing(1),
  },
}));

var positionCount = 0;
var collegeCount = 0;
var selectedplayer = [];
var playerCount = 0;
var selectedposition = [];
var selectedcollege = [];
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
export default function GroupComparePlayers() {
  const classes = useStyles();

  const params = useParams();
  const { user, selectedEventId, getActiveEventId, selectedCombineResultsTab } =
    useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  //const [eventId, setEventId] = useState(params.eventId);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [pName, setPName] = React.useState([]);
  const [cName, setCName] = React.useState([]);
  const [list, setList] = useState([]);
  const [listShootingDrill, setListShootingDrill] = useState([]);
  const [excelClick, setExcelClick] = useState(false);
  const blankDataset = [
    {
      columns: [
        {
          title: "No Records Found",
          width: { wpx: 500 },
        },
      ],
      data: [""].map((record) => {
        return [
          {
            value: record,
          },
        ];
      }),
    },
  ];

  const [sheetData, setSheetData] = useState({
    sheetName: "sheet1",
    dataset: blankDataset,
    key: 0,
  });
  const [sheetDataSAA, setSheetDataSAA] = useState({
    sheetName: "sheet2",
    dataset: blankDataset,
    key: 0,
  });
  const [sheetDataShootingDrill, setSheetDataShootingDrill] = useState({
    sheetName: "sheet3",
    dataset: blankDataset,
    key: 0,
  });
  const downloadExcel = () => {
    let excelData = exportToExcel();
    let excelDataSAA = exportToExcelSAA();
    let excelDataShootingDrill = exportToExcelShootingDrill();
    setSheetData({
      key: Math.trunc(Math.random() * 100),
      sheetName: "Anthropometry",
      dataset: excelData && excelData.length > 0 ? excelData : blankDataset,
    });
    setSheetDataSAA({
      key: Math.trunc(Math.random() * 100),
      sheetName: "Strength And Agility",
      dataset:
        excelDataSAA && excelDataSAA.length > 0 ? excelDataSAA : blankDataset,
    });
    setSheetDataShootingDrill({
      key: Math.trunc(Math.random() * 100),
      sheetName: "Shooting Drills",
      dataset:
        excelDataShootingDrill && excelDataShootingDrill.length > 0
          ? excelDataShootingDrill
          : blankDataset,
    });
    setExcelClick(true);
  };

  const exportToExcel = () => {
    const styleCss = {
      font: { sz: "11" },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const styleHeaderCss = {
      fill: {
        patternType: "solid",
        fgColor: { rgb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const aligmentCss = {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    };
    const arrColumnsName = [
      {
        title: `Player Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Position`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `College Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Body Fat`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Hand Dimensions-length`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Hand Dimensions-width`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Weight`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Height With Shoes`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Height Without Shoes`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Standing Reach`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Wingspan Dimensions`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
    ];

    const dataSetForDownload = [
      {
        columns: arrColumnsName,
        data: list.map((record) => {
          var handLength = "";
          var handwidth = "";
          var height = "";
          var heightwo = "";
          var sr = "";
          var wingspan = "";
          if (record.handLength !== "") {
            handLength = record.handLength;
          }
          if (handLength === 0) {
            handLength = "";
          }
          if (record.handWidth !== "") {
            handwidth = record.handWidth;
          }
          if (handwidth === 0) {
            handwidth = "";
          }
          if (
            record.heightWithShoesFeet !== "" &&
            record.heightWithShoesInches !== ""
          ) {
            height =
              record.heightWithShoesFeet +
              "'" +
              record.heightWithShoesInches +
              "''";
          }
          if (height === "0'0''") {
            height = "";
          }
          if (
            record.heightWithOutShoesFeet !== "" &&
            record.heightWithOutShoesInches !== ""
          ) {
            heightwo =
              record.heightWithOutShoesFeet +
              "'" +
              record.heightWithOutShoesInches +
              "''";
          }
          if (heightwo === "0'0''") {
            heightwo = "";
          }
          if (
            record.standingReachFeet !== "" &&
            record.standingReachInches !== ""
          ) {
            sr =
              record.standingReachFeet +
              "'" +
              record.standingReachInches +
              "''";
          }
          if (sr === "0'0''") {
            sr = "";
          }
          if (record.wingSpanFeet !== "" && record.wingSpanInches !== "") {
            wingspan = record.wingSpanFeet + "'" + record.wingSpanInches + "''";
          }
          if (wingspan === "0'0''") {
            wingspan = "";
          }
          return [
            {
              value: record.playerName ? record.playerName : "",
              style: styleCss,
              alignment: aligmentCss,
            },

            {
              value: record.position ? record.position : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.collegeOrClub ? record.collegeOrClub : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.bodyFat ? record.bodyFat : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: handLength,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: handwidth,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.bodyWeight ? record.bodyWeight : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: height,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: heightwo,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: sr,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: wingspan,
              style: styleCss,
              alignment: aligmentCss,
            },
          ];
        }),
      },
    ];
    return dataSetForDownload;
  };
  const exportToExcelSAA = () => {
    const styleCss = {
      font: { sz: "11" },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const styleHeaderCss = {
      fill: {
        patternType: "solid",
        fgColor: { rgb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const aligmentCss = {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    };
    const arrColumnsName = [
      {
        title: `Player Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Position`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `College Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Lane Shuttle Left`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Lane Shuttle Right`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `3/4 Court Sprint`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Pro Lane`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Max  Vertical Jump`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Standing Vertical`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
    ];

    const dataSetForDownload = [
      {
        columns: arrColumnsName,
        data: list.map((record) => {
          var mvj = "";
          var sv = "";

          mvj = record.maxVerticalLeap + "''";
          if (mvj === "0''") {
            mvj = "";
          }
          sv = record.standingVerticalLeap + "''";
          if (sv === "0''") {
            sv = "";
          }

          return [
            {
              value: record.playerName ? record.playerName : "",
              style: styleCss,
              alignment: aligmentCss,
            },

            {
              value: record.position ? record.position : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.collegeOrClub ? record.collegeOrClub : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.shuttleRunLeftTrialTime
                ? record.shuttleRunLeftTrialTime
                : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.shuttleRunRightTrialTime
                ? record.shuttleRunRightTrialTime
                : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.threeFourRunTime ? record.threeFourRunTime : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: record.proLaneTrialTime ? record.proLaneTrialTime : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: mvj,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: sv,
              style: styleCss,
              alignment: aligmentCss,
            },
          ];
        }),
      },
    ];
    return dataSetForDownload;
  };
  const exportToExcelShootingDrill = () => {
    const styleCss = {
      font: { sz: "11" },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const styleHeaderCss = {
      fill: {
        patternType: "solid",
        fgColor: { rgb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { wrapText: true, horizontal: "center", vertical: "top" },
    };
    const aligmentCss = {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    };
    const arrColumnsName = [
      {
        title: `Player Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Position`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },

      {
        title: `College Name`,
        width: { wpx: 300 },
        style: styleHeaderCss,
      },
      {
        title: `Spot Up Shooting`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Side Mid Side Drill`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Mid Side Mid Drill`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Off The Dribble Shooting`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Free Throws`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `3 Point Star Drill`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
      {
        title: `Mid Range Star Drill`,
        width: { wpx: 100 },
        style: styleHeaderCss,
      },
    ];

    const dataSetForDownload = [
      {
        columns: arrColumnsName,
        data: listShootingDrill.map((record) => {
          var SpotUpShooting =
            record.noOfMadeSpotup + "/" + record.maxCountSoptUp;
          var SMSDrill =
            record.noOfMadeSideMidSide + "/" + record.maxCountSideMidSide;
          var MSMDrill =
            record.noOfMadeMidSideMid + "/" + record.maxCountMidSideMid;
          var otds =
            record.noOfMadeOffTheDribble + "/" + record.maxCountOffTheDribble;
          var freethrows =
            record.noOfMadeFreeThrows + "/" + record.maxCountFreeThrows;
          var psdrill =
            record.noOfMade3PointStar + "/" + record.maxCount3PointStar;
          var msrdrill =
            record.noOfMadeMidRangeStar + "/" + record.maxCountMidRangeStar;

          return [
            {
              value: record.playerName ? record.playerName : "",
              style: styleCss,
              alignment: aligmentCss,
            },

            {
              value: record.position ? record.position : "",
              style: styleCss,
              alignment: aligmentCss,
            },

            {
              value: record.collegeOrClub ? record.collegeOrClub : "",
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: SpotUpShooting,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: SMSDrill,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: MSMDrill,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: otds,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: freethrows,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: psdrill,
              style: styleCss,
              alignment: aligmentCss,
            },
            {
              value: msrdrill,
              style: styleCss,
              alignment: aligmentCss,
            },
          ];
        }),
      },
    ];
    return dataSetForDownload;
  };
  const playerAnthrosAndStrengthAgiltyColumns = [
    {
      id: "playerName",
      headerName: "Player Name",
    },
    {
      id: "position",
      headerName: "Position",
    },
    {
      id: "collegeOrClub",
      headerName: "College Name",
    },
    {
      id: "bodyFat",
      headerName: "Body Fat",
    },
    {
      id: "handLength",
      headerName: "Hand Dimensions",
    },
    {
      id: "bodyWeight",
      headerName: "Weight",
    },
    {
      id: "heightWithShoesFeet",
      headerName: "Height With Shoes",
    },
    {
      id: "heightWithOutShoesFeet",
      headerName: "Height Without Shoes",
    },
    {
      id: "standingReachFeet",
      headerName: "Standing Reach",
    },
    {
      id: "wingSpanFeet",
      headerName: "Wingspan Dimension",
    },
    {
      id: "shuttleRunLeftTrialTime",
      headerName: "Lane Shuttle Left",
    },
    {
      id: "shuttleRunRightTrialTime",
      headerName: "Lane Shuttle Right",
    },
    {
      id: "threeFourRunTime",
      headerName: "3/4 Court Sprint",
    },
    {
      id: "proLaneTrialTime",
      headerName: "Pro Lane",
    },
    {
      id: "maxVerticalLeap",
      headerName: "Max Vertical Jump",
    },
    {
      id: "standingVerticalLeap",
      headerName: "Standing Vertical",
    },
  ];

  const playerShootingDrillsColumns = [
    {
      id: "playerName",
      headerName: "Player Name",
    },
    {
      id: "position",
      headerName: "Position",
    },
    {
      id: "collegeOrClub",
      headerName: "College Name",
    },
    {
      id: "noOfMadeSpotup",
      headerName: "Spot Up",
    },
    {
      id: "noOfMadeSideMidSide",
      headerName: "Side Mid Side",
    },
    {
      id: "noOfMadeMidSideMid",
      headerName: "Mid Side Mid",
    },
    {
      id: "noOfMadeOffTheDribble",
      headerName: "Off The Dribble",
    },
    {
      id: "noOfMadeFreeThrows",
      headerName: "Free Throws",
    },
    {
      id: "noOfMade3PointStar",
      headerName: "3 Point Star",
    },
    {
      id: "noOfMadeMidRangeStar",
      headerName: "Mid Range Star",
    },
  ];

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    if (selectedplayer.length === 0) {
      playerCount = playerCount + 1;
    } else if (selectedplayer.length <= value.length) {
      playerCount = playerCount + 1;
    } else if (selectedplayer.length > value.length) {
      playerCount = playerCount - 1;
    }
    selectedplayer = value;
    setPersonName(value);
    getplayer(value);
    setPlayerValue(value);
  };
  const handleChangeCollege = (event) => {
    const {
      target: { value },
    } = event;

    if (selectedcollege.length === 0) {
      collegeCount = collegeCount + 1;
    } else if (selectedcollege.length <= value.length) {
      collegeCount = collegeCount + 1;
    } else if (selectedcollege.length > value.length) {
      collegeCount = collegeCount - 1;
    }
    selectedcollege = value;

    setCName(value);
    getplayerCollege(value);
    setCollegeValue(value);
  };
  const handleChangePosition = (event) => {
    const {
      target: { value },
    } = event;

    if (selectedposition.length === 0) {
      positionCount = positionCount + 1;
    } else if (selectedposition.length <= value.length) {
      positionCount = positionCount + 1;
    } else if (selectedposition.length > value.length) {
      positionCount = positionCount - 1;
    }
    selectedposition = value;

    setPName(value);
    getplayerPosition(value);
    setPositionValue(value);
  };

  function getplayer(value) {
    setfavPlayersASADataselected([]);
    setfavPlayersShootingDrillDataselected([]);
    if (value.length > 0) {
      var playerList = [];
      var posList = [];
      var colList = [];
      var player;
      var playerpos;
      var playercol;
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (var i = 0; i < value.length; ++i) {
        player = favPlayersASAData.filter((val, index) => {
          return val.playerName === value[i];
        });
        playerList = [...playerList, ...player];
        playerDrill = favPlayersShootingDrillData.filter((val, index) => {
          return val.playerName === value[i];
        });
        playerDrillList = [...playerDrillList, ...playerDrill];
      }

      if (selectedposition.length > 0) {
        for (var j = 0; j < selectedposition.length; ++j) {
          playerpos = playerList.filter((val, index) => {
            return val.position === selectedposition[j];
          });
          posList = [...posList, ...playerpos];
          playerDrillpos = playerDrillList.filter((val, index) => {
            return val.position === selectedposition[j];
          });
          playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
        }
      } else {
        posList = playerList;
        playerDrillListpos = playerDrillList;
      }
      if (selectedcollege.length > 0) {
        for (var k = 0; k < selectedcollege.length; ++k) {
          playercol = posList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          colList = [...colList, ...playercol];
          playerDrillcol = playerDrillListpos.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
        }
      } else {
        colList = posList;
        playerDrillListcol = playerDrillListpos;
      }
      var filterdata = [...colList];
      var newfilterdata = filterdata.filter(function (elem, pos) {
        return filterdata.indexOf(elem) === pos;
      });

      var drillfilterdata = [...playerDrillListcol];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });
      playerSelected = true;
      setfavPlayersASADataselected(newfilterdata);
      setList(newfilterdata);

      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setListShootingDrill(newdrillfilterdata);
      setShowval(true);
    } else {
      setShowval(false);
      setList(favPlayersASAData);
      setListShootingDrill(favPlayersShootingDrillData);
      playerSelected = false;
    }
  }
  function getplayersAfterdelete(value) {
    if (value !== "") {
      var playerList = [];
      var player;
      var playerDrillList = [];
      var playerDrill;
      playerSelected = true;
      player = favPlayersASADataselected.filter((val, index) => {
        return val.playerName !== value;
      });

      playerList = [...playerList, ...player];
      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.playerName !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      setfavPlayersASADataselected(playerList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setList(playerList);
      setListShootingDrill(playerDrillList);
      if (playerCount === 0) {
        setShowval(false);
        setList(favPlayersASAData);
        setListShootingDrill(favPlayersShootingDrillData);

        if (collegeValue !== "" && collegeCount !== 0) {
          getplayerCollege(collegeValue);
          if (positionValue !== "" && positionCount !== 0) {
            getplayerPosition(positionValue);
          }
        } else if (positionValue !== "" && positionCount !== 0) {
          getplayerPosition(pName);
          if (collegeValue !== "" && collegeCount !== 0) {
            getplayerCollege(collegeValue);
          }
        }
      } else {
        setShowval(true);
      }
    } else {
      if (positionSelected === false) {
        setShowval(false);
        setList(favPlayersASAData);
        setListShootingDrill(favPlayersShootingDrillData);
      }
      playerSelected = false;
    }
  }
  function getpositionAfterdelete(value) {
    if (value !== "") {
      var playerList = [];
      var player;
      var playerDrillList = [];
      var playerDrill;

      player = favPlayersASADataselected.filter((val, index) => {
        return val.position !== value;
      });
      playerList = [...playerList, ...player];

      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.position !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      positionSelected = true;
      setfavPlayersASADataselected(playerList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setList(playerList);
      setListShootingDrill(playerDrillList);
      if (positionCount === 0) {
        setShowval(false);
        setList(favPlayersASAData);
        setListShootingDrill(favPlayersShootingDrillData);
        if (playerValue !== "" && playerCount !== 0) {
          getplayer(playerValue);
          if (collegeValue !== "" && collegeCount !== 0) {
            getplayerCollege(collegeValue);
          }
        } else if (collegeValue !== "" && collegeCount !== 0) {
          getplayerCollege(collegeValue);
          setListShootingDrill(favPlayersShootingDrillData);
          if (playerValue !== "" && playerCount !== 0) {
            getplayer(playerValue);
          }
        }
      } else {
        setShowval(true);
      }
    } else {
      setShowval(false);
      setList(favPlayersASAData);
      setListShootingDrill(favPlayersShootingDrillData);
      positionSelected = false;
    }
  }
  function getcollegeAfterdelete(value) {
    if (value !== "") {
      var playerList = [];
      var player;
      var playerDrillList = [];
      var playerDrill;

      player = favPlayersASADataselected.filter((val, index) => {
        return val.collegeOrClub !== value;
      });
      playerList = [...playerList, ...player];

      playerDrill = favPlayersShootingDrillDataselected.filter((val, index) => {
        return val.collegeOrClub !== value;
      });
      playerDrillList = [...playerDrillList, ...playerDrill];

      collegeSelected = true;
      setfavPlayersASADataselected(playerList);
      setfavPlayersShootingDrillDataselected(playerDrillList);
      setList(playerList);
      setListShootingDrill(playerDrillList);
      if (collegeCount === 0) {
        setShowval(false);
        setList(favPlayersASAData);
        setListShootingDrill(favPlayersShootingDrillData);
        if (playerValue !== "" && playerCount !== 0) {
          getplayer(playerValue);
          if (positionValue !== "" && positionCount !== 0) {
            getplayerPosition(positionValue);
          }
        } else if (positionValue !== "" && positionCount !== 0) {
          getplayerPosition(positionValue);
          if (playerValue !== "" && playerCount !== 0) {
            getplayer(playerValue);
          }
        }
      } else {
        setShowval(true);
      }
    } else {
      setShowval(false);
      setList(favPlayersASAData);
      setListShootingDrill(favPlayersShootingDrillData);
      collegeSelected = false;
    }
  }
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  function getplayerPosition(value) {
    setfavPlayersASADataselected([]);
    setfavPlayersShootingDrillDataselected([]);
    if (value.length > 0) {
      var playerList = [];
      var posList = [];
      var colList = [];
      var player;
      var playerpos;
      var playercol;
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (var i = 0; i < value.length; ++i) {
        playerpos = favPlayersASAData.filter((val, index) => {
          return val.position === value[i];
        });
        posList = [...posList, ...playerpos];

        playerDrillpos = favPlayersShootingDrillData.filter((val, index) => {
          return val.position === value[i];
        });
        playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
      }
      if (selectedplayer.length > 0) {
        for (var j = 0; j < selectedplayer.length; ++j) {
          player = posList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerList = [...playerList, ...player];
          playerDrill = playerDrillpos.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerDrillList = [...playerDrillList, ...playerDrill];
        }
      } else {
        playerList = posList;
        playerDrillList = playerDrillpos;
      }

      if (selectedcollege.length > 0) {
        for (var k = 0; k < selectedcollege.length; ++k) {
          playercol = playerList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          colList = [...colList, ...playercol];
          playerDrillcol = playerDrillList.filter((val, index) => {
            return val.collegeOrClub === selectedcollege[k];
          });
          playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
        }
      } else {
        colList = playerList;
        playerDrillListcol = playerDrillList;
      }
      var filterdata = [...colList];
      var newfilterdata = filterdata.filter(function (elem, pos) {
        return filterdata.indexOf(elem) === pos;
      });
      var drillfilterdata = [...playerDrillListcol];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });
      positionSelected = true;
      setfavPlayersASADataselected(newfilterdata);
      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setList(newfilterdata);
      setListShootingDrill(newdrillfilterdata);

      setShowval(true);
    } else {
      setShowval(false);
      setList(favPlayersASAData);
      setListShootingDrill(favPlayersShootingDrillData);
      // getplayer1(playerValue);

      positionSelected = false;
    }
  }
  function getplayerCollege(value) {
    setfavPlayersASADataselected([]);
    setfavPlayersShootingDrillDataselected([]);
    if (value.length > 0) {
      var playerList = [];
      var posList = [];
      var colList = [];
      var player;
      var playerpos;
      var playercol;
      var playerDrillList = [];
      var playerDrillListpos = [];
      var playerDrillListcol = [];
      var playerDrill;
      var playerDrillpos;
      var playerDrillcol;

      for (var i = 0; i < value.length; ++i) {
        playercol = favPlayersASAData.filter((val, index) => {
          return val.collegeOrClub === value[i];
        });
        colList = [...colList, ...playercol];

        playerDrillcol = favPlayersShootingDrillData.filter((val, index) => {
          return val.collegeOrClub === value[i];
        });
        playerDrillListcol = [...playerDrillListcol, ...playerDrillcol];
      }

      if (selectedplayer.length > 0) {
        for (var j = 0; j < selectedplayer.length; ++j) {
          player = colList.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerList = [...playerList, ...player];
          playerDrill = playerDrillListcol.filter((val, index) => {
            return val.playerName === selectedplayer[j];
          });
          playerDrillList = [...playerDrillList, ...playerDrill];
        }
      } else {
        playerList = colList;
        playerDrillList = playerDrillListcol;
      }

      if (selectedposition.length > 0) {
        for (var k = 0; k < selectedposition.length; ++k) {
          playerpos = playerList.filter((val, index) => {
            return val.position === selectedposition[k];
          });
          posList = [...posList, ...playerpos];
          playerDrillpos = playerDrillList.filter((val, index) => {
            return val.position === selectedposition[k];
          });
          playerDrillListpos = [...playerDrillListpos, ...playerDrillpos];
        }
      } else {
        posList = playerList;
        playerDrillListpos = playerDrillList;
      }
      var filterdata = [...posList];
      var newfilterdata = filterdata.filter(function (elem, pos) {
        return filterdata.indexOf(elem) === pos;
      });
      var drillfilterdata = [...playerDrillListpos];
      var newdrillfilterdata = drillfilterdata.filter(function (elem, pos) {
        return drillfilterdata.indexOf(elem) === pos;
      });

      collegeSelected = true;
      setfavPlayersASADataselected(newfilterdata);
      setfavPlayersShootingDrillDataselected(newdrillfilterdata);
      setList(newfilterdata);
      setListShootingDrill(newdrillfilterdata);

      setShowval(true);
    } else {
      setShowval(false);
      setList(favPlayersASAData);
      setListShootingDrill(favPlayersShootingDrillData);
      // getplayer1(playerValue);

      collegeSelected = false;
    }
  }
  const [strengthAgilityFlag, setStrengthAgilityFlag] = useState([]);
  const [selectedTab, setSelectedTab] = useState(selectedCombineResultsTab);
  const [laneShuttleLeft, setLaneShuttleLeft] = useState({
    active: false,
    data: [],
  });
  const [laneShuttleRight, setLaneShuttleRight] = useState({
    active: false,
    data: [],
  });
  const [threeFour, setThreeFour] = useState({ active: false, data: [] });
  const [proLane, setPROLane] = useState({ active: false, data: [] });
  const [maxVerticalJump, setMaxVerticalJump] = useState({
    active: false,
    data: [],
  });
  const [standingVerticalJump, setStandingVerticalJump] = useState({
    active: false,
    data: [],
  });

  /// Anthros LeaderBoard

  const [bodyFat, setBodyFat] = useState({ active: false, data: [] });
  const [handDimentions, setHandDimentions] = useState({
    active: false,
    data: [],
  });
  const [weight, setWeight] = useState({ active: false, data: [] });
  const [heightWithShoes, setHeightWithShoes] = useState({
    active: false,
    data: [],
  });
  const [heightWithoutShoes, setHeightWithoutShoes] = useState({
    active: false,
    data: [],
  });
  const [standingReach, setStandingReach] = useState({
    active: false,
    data: [],
  });
  const [wingSpanDimentions, setWingSpanDimentions] = useState({
    active: false,
    data: [],
  });
  const [spotUp, setSpotUp] = useState({
    active: false,
    data: [],
  });
  const [sideMidSide, setSideMidSide] = useState({
    active: false,
    data: [],
  });
  const [midSideMid, setMidSideMid] = useState({
    active: false,
    data: [],
  });
  const [offTheDribble, setOffTheDribble] = useState({
    active: false,
    data: [],
  });
  const [freeThrows, setFreeThrows] = useState({
    active: false,
    data: [],
  });
  const [point3Star, setPoint3Star] = useState({
    active: false,
    data: [],
  });
  const [midRangeStar, setMidRangeStar] = useState({
    active: false,
    data: [],
  });
  const [notes, setNotes] = useState([]);

  const [favPlayersASAData, setfavPlayersASAData] = useState([]);
  const [favPlayersASADataselected, setfavPlayersASADataselected] = useState(
    []
  );
  const [playerName, setplayerName] = useState([]);
  const [collegeName, setcollegeName] = useState([]);
  const [positionName, setPositionName] = useState([]);
  const [playerValue, setPlayerValue] = useState([]);
  const [positionValue, setPositionValue] = useState([]);
  const [collegeValue, setCollegeValue] = useState([]);
  const [Showval, setShowval] = useState(false);
  const [favPlayersShootingDrillData, setfavPlayersShootingDrillData] =
    useState([]);
  const [
    favPlayersShootingDrillDataselected,
    setfavPlayersShootingDrillDataselected,
  ] = useState([]);

  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);

  useEffect(() => {
    if (eventId !== 0 && user && user.loginID) {
      setLoading(true);
      GetLeaderBoardFlags();
      GetLeaderBoardNotes();
      GetAllPlayers();
      GetAllPositions();
      GetgetShootingDrillLeaderBoardByEventID();
      GetLeaderboardAnthroSAAgilityByEventID();
    } else {
      setLoading(true);
      // getActiveEventId();
    }
  }, [user, eventId]);
  useEffect(() => {
    if (excelClick) {
      document.getElementById("combineresult-list-excel-export").click();
      setExcelClick(false);
    }
  }, [excelClick]);

  const GetgetShootingDrillLeaderBoardByEventID = async () => {
    let data =
      await LeaderDashboardService.getShootingDrillLeaderBoardByEventID(
        eventId,
        user?.loginID
      );
    setfavPlayersShootingDrillData(data.data);
    setListShootingDrill(data.data);
  };
  const GetAllPlayers = async () => {
    PlayerProfileService.getPlayerListByEventIdYear(eventId, user?.loginID)
      .then((result) => {
        var playerName = [];
        var collegename = [];
        var newcollegename = [];
        var sortedcollegeName = [];

        for (var i = 0; i < result.data.length; ++i) {
          playerName = [...playerName, result.data[i].playerName];
          collegename = [...collegename, result.data[i].collegeOrClub];
        }

        newcollegename = collegename.filter(function (elem, pos) {
          return collegename.indexOf(elem) === pos;
        });

        var sortedcollegeName = newcollegename.sort(function (a, b) {
          return a.localeCompare(b); //using String.prototype.localCompare()
        });

        setplayerName(playerName);
        setcollegeName(sortedcollegeName);
        return result;
      })
      .catch(handleError);
  };

  const GetAllPositions = async () => {
    PlayerProfileService.getPlayerPositions()
      .then((result) => {
        var playingPosition = [];
        for (var i = 0; i < result.data.length; ++i) {
          //   if (result.data[i].childName === "C" || result.data[i].childName === "G"|| result.data[i].childName === "F")
          playingPosition = [...playingPosition, result.data[i].childName];
        }
        var sortedpos = playingPosition.sort(function (a, b) {
          return a.localeCompare(b); //using String.prototype.localCompare()
        });
        setPositionName(sortedpos);

        return result;
      })
      .catch(handleError);
  };

  const GetLeaderboardAnthroSAAgilityByEventID = async () => {
    let data =
      await LeaderDashboardService.getLeaderboardAnthroSAAgilityByEventID(
        eventId,
        user?.loginID
      );
    setfavPlayersASAData(data.data);
    setList(data.data);
  };

  const GetLeaderBoardFlags = async () => {
    let flags = await LeaderDashboardService.getStrengthAndAgilityFlag();
    setStrengthAgilityFlag(flags.data);
  };

  const GetLeaderBoardNotes = async () => {
    let data = await LeaderDashboardService.getLeaderBoardNotes();
    //setNotes(data.data);

    //Filter the notes based on event.
    const filteredData = data.data.filter(
      (notes) => notes.childID === parseInt(selectedEventId)
    );

    //Make all unique notes and set to respective state.
    setNotes([...new Map(filteredData.map((m) => [m.childName, m])).values()]);
  };
  const handleDelete = (e, value) => {
    e.preventDefault();
    setPersonName((current) => _without(current, value));
    selectedplayer = selectedplayer.filter((val, index) => {
      return val !== value;
    });
    playerCount = playerCount - 1;
    getplayersAfterdelete(value);
  };
  const handleDeleteCollege = (e, value) => {
    e.preventDefault();
    setCName((current) => _without(current, value));
    selectedcollege = selectedcollege.filter((val, index) => {
      return val !== value;
    });
    collegeCount = collegeCount - 1;
    getcollegeAfterdelete(value);
  };
  const handleDeletePosition = (e, value) => {
    e.preventDefault();
    setPName((current) => _without(current, value));
    selectedposition = selectedposition.filter((val, index) => {
      return val !== value;
    });
    positionCount = positionCount - 1;
    getpositionAfterdelete(value);
  };
  useEffect(() => {
    GetStrengthAndAgilityData();
    GetAnthrosLeaderBoardData();
    GetShootingDrillsData();
  }, [strengthAgilityFlag]);

  const GetStrengthAndAgilityData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (
          flag.childID < 7 &&
          strengthAndAgilityStations.includes(flag.childName)
        ) {
          setLoading(true);
          if (flag.childID == 1 && flag.childName == 201) {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              0,
              2010,
              flag.isActive,
              user?.loginID
            );
          } else if (flag.childID == 2 && flag.childName == 201) {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              1,
              2011,
              flag.isActive,
              user?.loginID
            );
          } else {
            GetStrengthAndAgilityDataByStationId(
              eventId,
              flag.childName,
              0,
              flag.childName,
              flag.isActive,
              user?.loginID
            );
          }
        }
      });
    }
  };

  const GetAnthrosLeaderBoardData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (flag.childID > 6 && anthrosStations.includes(flag.childName)) {
          GetAnthrosLeaderBoardByStationId(
            eventId,
            flag.childName,
            flag.isActive,
            user?.loginID
          );
        }
      });
    }
  };

  const GetShootingDrillsData = () => {
    if (strengthAgilityFlag && strengthAgilityFlag.length > 0) {
      strengthAgilityFlag.forEach((flag) => {
        if (flag.childID > 13 && shootingStations.includes(flag.childName)) {
          GetShootingDrillsByStationId(
            eventId,
            flag.childName,
            flag.isActive,
            user?.loginID
          );
        }
      });
    }
  };

  const GetAnthrosLeaderBoardByStationId = async (
    eventId,
    stationId,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data = await LeaderDashboardService.getAnthrosLeaderBoardByStationId(
      eventId,
      stationId,
      userBy
    );
    setLoading(false);
    switch (stationId) {
      case (stationId = "101"):
        setBodyFat({ active: isActive, data: data.data });
        return;
      case (stationId = "102"):
        setHandDimentions({ active: isActive, data: data.data });
        return;
      case (stationId = "103"):
        setWeight({ active: isActive, data: data.data });
        return;
      case (stationId = "104"):
        setHeightWithShoes({ active: isActive, data: data.data });
        return;
      case (stationId = "105"):
        setHeightWithoutShoes({ active: isActive, data: data.data });
        return;
      case (stationId = "106"):
        setStandingReach({ active: isActive, data: data.data });
        return;
      case (stationId = "107"):
        setWingSpanDimentions({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  const GetStrengthAndAgilityDataByStationId = async (
    eventId,
    stationId,
    state,
    value,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data =
      await LeaderDashboardService.getStrengthAndAgilityDataByStationId(
        eventId,
        stationId,
        state,
        userBy
      );
    setLoading(false);
    switch (value) {
      case (value = 2010):
        setLaneShuttleLeft({ active: isActive, data: data.data });
        return;
      case (value = 2011):
        setLaneShuttleRight({ active: isActive, data: data.data });
        return;
      case (value = "202"):
        setThreeFour({ active: isActive, data: data.data });
        return;
      case (value = "203"):
        setPROLane({ active: isActive, data: data.data });
        return;
      case (value = "204"):
        setMaxVerticalJump({ active: isActive, data: data.data });
        return;
      case (value = "205"):
        setStandingVerticalJump({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  const GetShootingDrillsByStationId = async (
    eventId,
    stationId,
    isActive,
    userBy
  ) => {
    setLoading(true);
    let data = await LeaderDashboardService.getShootingDrillsByStationId(
      eventId,
      stationId,
      userBy
    );
    setLoading(false);
    switch (stationId) {
      case (stationId = "301"):
        setSpotUp({ active: isActive, data: data.data });
        return;
      case (stationId = "302"):
        setSideMidSide({ active: isActive, data: data.data });
        return;
      case (stationId = "303"):
        setOffTheDribble({ active: isActive, data: data.data });
        return;
      case (stationId = "304"):
        setFreeThrows({ active: isActive, data: data.data });
        return;
      case (stationId = "305"):
        setPoint3Star({ active: isActive, data: data.data });
        return;
      case (stationId = "306"):
        setMidRangeStar({ active: isActive, data: data.data });
        return;
      case (stationId = "307"):
        setMidSideMid({ active: isActive, data: data.data });
        return;
      default:
        return;
    }
  };

  function descendingComparator(a, b, sortOrder, sortOrderBy) {
    if (a[sortOrderBy] === b[sortOrderBy]) {
      return 0;
    } else if (sortOrder === "asc") {
      return a[sortOrderBy] < b[sortOrderBy] ? -1 : 1;
    } else {
      return a[sortOrderBy] < b[sortOrderBy] ? 1 : -1;
    }
  }

  useEffect(() => {
    AdminPreferencesService.getCombineYears().then((response) => {
      let combineYearData = [];
      response.data.forEach((item) => {
        combineYearData.push({
          combineYear: item,
        });
      });
    });
  }, []);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  return (
    <Container maxWidth={false}>
      <Grid container mt={2} mb={2} spacing={2}>
        <Grid item lg={3}>
          <Typography>Select Position</Typography>

          <FormControl sx={{ m: 1 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label-pos">Position</InputLabel>
            <Select
              labelId="demo-multiple-chip-label-pos"
              id="demo-multiple-chip-pos"
              multiple
              value={pName}
              onChange={handleChangePosition}
              input={
                <OutlinedInput id="select-multiple-chip-pos" label="Chip" />
              }
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDeletePosition(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {positionName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles1(name, pName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item lg={3}>
          <Typography>Select Players</Typography>

          <FormControl sx={{ m: 1 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label"> Name</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={personName}
              onChange={handleChange}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDelete(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {playerName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles(name, personName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <Typography>Select College</Typography>

          <FormControl sx={{ m: 1 }} size="small" fullWidth>
            <InputLabel id="demo-multiple-chip-label-college">
              {" "}
              College
            </InputLabel>
            <Select
              labelId="demo-multiple-chip-label-college"
              id="demo-multiple-chip-college"
              multiple
              value={cName}
              onChange={handleChangeCollege}
              input={
                <OutlinedInput id="select-multiple-chip-college" label="Chip" />
              }
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value, index) => (
                    <Chip
                      key={index}
                      label={value}
                      clickable
                      onDelete={(e) => {
                        handleDeleteCollege(e, value);
                      }}
                      deleteIcon={
                        <CancelIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      }
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {collegeName.map((name, index) => (
                <MenuItem
                  key={index}
                  value={name}
                  style={getStyles(name, cName, theme)}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container pt={2} pb={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid container>
            <Grid item lg xs={12}>
              <Paper
                elevation={8}
                sx={{
                  borderRadius: "16px",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  flexGrow={1}
                  flexDirection="column"
                  className={classes.paperStyle}
                >
                  <AppBar
                    position="static"
                    className={classes.appbar}
                    sx={{
                      borderTopLeftRadius: "15px !important",
                      borderTopRightRadius: "15px !important",
                    }}
                  >
                    <Hidden mdUp>
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="scrollable"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Anthropometry"
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Strength And Agility"
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Shooting Drills"
                          {...a11yProps(2)}
                        />
                        <Box className={classes.excelButton}>
                          {/* <ExcelFile
                            filename={"Combine Result"}
                            element={
                              <IconButton id="combineresult-list-excel-export"></IconButton>
                            }
                          >
                            <ExcelSheet
                              dataSet={sheetData.dataset}
                              name={sheetData.sheetName}
                              key={sheetData.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataSAA.dataset}
                              name={sheetDataSAA.sheetName}
                              key={sheetDataSAA.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataShootingDrill.dataset}
                              name={sheetDataShootingDrill.sheetName}
                              key={sheetDataShootingDrill.key}
                            />
                          </ExcelFile> */}
                          <Button
                            size="small"
                            className={classes.exportToExcel}
                            title="Export to Excel"
                            sx={{
                              border: "1px solid lightgrey",
                              boxShadow: "1px 1px 3px black",
                              minWidth: "auto !important",
                            }}
                            onClick={downloadExcel}
                          >
                            <img
                              alt="pngImg"
                              src="../../../../playerProfile/excel.png"
                              width="26"
                              height="26"
                            />
                          </Button>
                        </Box>
                      </Tabs>
                    </Hidden>
                    <Hidden mdDown>
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="standard"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Anthropometry"
                          {...a11yProps(0)}
                        ></Tab>
                        <Tab
                          sx={{ textTransform: "none" }}
                          label=" Strength And Agility"
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Shooting Drills"
                          {...a11yProps(2)}
                        />
                        <Box className={classes.excelButton}>
                          {/* <ExcelFile
                            filename={"Combine Result"}
                            element={
                              <IconButton id="combineresult-list-excel-export"></IconButton>
                            }
                          >
                            <ExcelSheet
                              dataSet={sheetData.dataset}
                              name={sheetData.sheetName}
                              key={sheetData.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataSAA.dataset}
                              name={sheetDataSAA.sheetName}
                              key={sheetDataSAA.key}
                            />
                            <ExcelSheet
                              dataSet={sheetDataShootingDrill.dataset}
                              name={sheetDataShootingDrill.sheetName}
                              key={sheetDataShootingDrill.key}
                            />
                          </ExcelFile> */}
                          <Button
                            size="small"
                            className={classes.exportToExcel}
                            title="Export to Excel"
                            sx={{
                              border: "1px solid lightgrey",
                              boxShadow: "1px 1px 3px black",
                              minWidth: "auto !important",
                            }}
                            onClick={downloadExcel}
                          >
                            <img
                              alt="pngImg"
                              src="../../../../playerProfile/excel.png"
                              width="26"
                              height="26"
                            />
                          </Button>
                        </Box>
                      </Tabs>
                    </Hidden>
                  </AppBar>
                  <SwipeableViews
                    className={classes.swipeView}
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={selectedTab}
                    onChangeIndex={handleChangeIndex}
                  >
                    {/* Tab 1 */}
                    <TabPanel
                      value={selectedTab}
                      index={0}
                      dir={theme.direction}
                    >
                      <ComparePlayersAnthros
                        favPlayersASAData={favPlayersASAData}
                        favPlayersASADataselected={favPlayersASADataselected}
                        playerAnthrosAndStrengthAgiltyColumns={
                          playerAnthrosAndStrengthAgiltyColumns
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        bodyFat={bodyFat}
                        handDimentions={handDimentions}
                        weight={weight}
                        heightWithShoes={heightWithShoes}
                        heightWithoutShoes={heightWithoutShoes}
                        standingReach={standingReach}
                        wingSpanDimentions={wingSpanDimentions}
                        eventId={eventId}
                      />
                    </TabPanel>

                    <TabPanel
                      value={selectedTab}
                      index={1}
                      dir={theme.direction}
                    >
                      <ComparePlayersSAA
                        favPlayersASAData={favPlayersASAData}
                        favPlayersASADataselected={favPlayersASADataselected}
                        playerAnthrosAndStrengthAgiltyColumns={
                          playerAnthrosAndStrengthAgiltyColumns
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        laneShuttleLeft={laneShuttleLeft}
                        laneShuttleRight={laneShuttleRight}
                        threeFour={threeFour}
                        proLane={proLane}
                        maxVerticalJump={maxVerticalJump}
                        standingVerticalJump={standingVerticalJump}
                        eventId={eventId}
                      />
                    </TabPanel>
                    <TabPanel
                      value={selectedTab}
                      index={2}
                      dir={theme.direction}
                    >
                      <ComparePlayersShootingDrills
                        favPlayersShootingDrillData={
                          favPlayersShootingDrillData
                        }
                        playerShootingDrillsColumns={
                          playerShootingDrillsColumns
                        }
                        favPlayersShootingDrillDataselected={
                          favPlayersShootingDrillDataselected
                        }
                        Showval={Showval}
                        notes={notes}
                        loading={loading}
                        spotUp={spotUp}
                        sideMidSide={sideMidSide}
                        midSideMid={midSideMid}
                        offTheDribble={offTheDribble}
                        freeThrows={freeThrows}
                        point3Star={point3Star}
                        midRangeStar={midRangeStar}
                        eventId={eventId}
                      />
                    </TabPanel>
                  </SwipeableViews>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
